<ng-template #alertTemplate>
  @if (isOpen()) {
    <div 
      class="so-alert-backdrop" 
      [class.so-alert-backdrop--closing]="isClosing()"
      (click)="onBackdropClick()"
    >
      <div [ngClass]="alertClasses()" (click)="onModalClick($event)">
        <!-- Close button -->
        @if (showCloseButton()) {
          <button 
            class="so-alert-modal__close" 
            (click)="close()"
            type="button"
            aria-label="Cerrar"
          >
            <span class="material-icons">close</span>
          </button>
        }
        
        <!-- Icon -->
        @if (showIcon()) {
          <div class="so-alert-modal__icon-wrapper">
            <div class="so-alert-modal__icon">
              <span class="material-icons">{{ defaultIcon() }}</span>
            </div>
          </div>
        }
        
        <!-- Content -->
        <div class="so-alert-modal__content">
          @if (title()) {
            <h3 class="so-alert-modal__title">{{ title() }}</h3>
          }
          @if (content()) {
            <p class="so-alert-modal__text">{{ content() }}</p>
          }
          @if (hasConfirmInput()) {
            <div class="so-alert-modal__confirm">
              <label class="so-alert-modal__confirm-label so-alert-modal__sr-only" [for]="confirmInputId">
                {{ confirmLabel() }}
              </label>
              <input
                [id]="confirmInputId"
                type="text"
                class="so-alert-modal__confirm-input"
                [value]="typedValue()"
                [placeholder]="confirmPlaceholder() || confirmLabel()"
                (input)="onConfirmInputChange($any($event.target).value)"
                autocomplete="off"
              />
            </div>
          }
        </div>
        
        <!-- Action buttons -->
        @if (hasButtons()) {
          <div class="so-alert-modal__actions">
            @for (button of buttons(); track button.label) {
              <so-button-gradient-ui
                [text]="button.label"
                [variant]="button.variant || 'solid'"
                [color]="getButtonColor(button.color)"
                [disabled]="(button.disabled || false) || isConfirmLocked(button)"
                (clicked)="handleButtonClick(button)"
              />
            }
          </div>
        }
      </div>
    </div>
  }
</ng-template>